import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

import { createBrowserHistory } from 'history';

// allow the app to run in a subdirectory by enabling this in the history
// and adding a 'base' element to the application
export const history = createBrowserHistory({
    basename: process.env.PUBLIC_URL
});

/*let base = document.createElement('base');
base.setAttribute('href', process.env.PUBLIC_URL);
document.head.append(base);*/

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// add a base element to the document head to allow it to be deployed in
// subdirectories

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
